import { StarAddIconProps } from './StarAddIcon.types'

export const StarAddIcon = ({ className }: StarAddIconProps) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    className={className}
    fill='none'
  >
    <g
      id='🔍-Product-Icons'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='ic_fluent_star_add_24_filled'
        fill='currentColor'
        fillRule='nonzero'
      >
        <path
          d='M17.5,12 C20.5375661,12 23,14.4624339 23,17.5 C23,20.5375661 20.5375661,23 17.5,23 C14.4624339,23 12,20.5375661 12,17.5 C12,14.4624339 14.4624339,12 17.5,12 Z M12.6728137,2.75963841 L15.3563695,8.20794048 L21.3672771,9.07653583 C21.9828509,9.16548822 22.2288847,9.92194118 21.7834166,10.355994 L20.4150744,11.6887401 C19.5383373,11.2480855 18.5481404,11 17.5,11 C13.9101491,11 11,13.9101491 11,17.5 C11,18.0076195 11.0581888,18.5016483 11.1682599,18.9757801 L6.6265261,21.3681981 C6.07605002,21.6581549 5.43223188,21.1903936 5.53789075,20.5772582 L6.56928006,14.5921347 L2.21690124,10.3563034 C1.77102944,9.92237116 2.01694609,9.16551755 2.63272295,9.07653583 L8.6436305,8.20794048 L11.3271863,2.75963841 C11.6020985,2.20149668 12.3979015,2.20149668 12.6728137,2.75963841 Z M17.5,13.9992349 L17.4101244,14.0072906 C17.2060313,14.0443345 17.0450996,14.2052662 17.0080557,14.4093593 L17,14.4992349 L16.9996498,16.9992349 L14.4976498,17 L14.4077742,17.0080557 C14.2036811,17.0450996 14.0427494,17.2060313 14.0057055,17.4101244 L13.9976498,17.5 L14.0057055,17.5898756 C14.0427494,17.7939687 14.2036811,17.9549004 14.4077742,17.9919443 L14.4976498,18 L17.0006498,17.9992349 L17.0011076,20.5034847 L17.0091633,20.5933603 C17.0462073,20.7974534 17.207139,20.9583851 17.411232,20.995429 L17.5011076,21.0034847 L17.5909833,20.995429 C17.7950763,20.9583851 17.956008,20.7974534 17.993052,20.5933603 L18.0011076,20.5034847 L18.0006498,17.9992349 L20.5045655,18 L20.5944411,17.9919443 C20.7985342,17.9549004 20.9594659,17.7939687 20.9965098,17.5898756 L21.0045655,17.5 L20.9965098,17.4101244 C20.9594659,17.2060313 20.7985342,17.0450996 20.5944411,17.0080557 L20.5045655,17 L17.9996498,16.9992349 L18,14.4992349 L17.9919443,14.4093593 C17.9549004,14.2052662 17.7939687,14.0443345 17.5898756,14.0072906 L17.5,13.9992349 Z'
          id='🎨-Color'
        ></path>
      </g>
    </g>
  </svg>
)
